import PropTypes from "prop-types";

/**
 * @typedef {Object} MetricItem
 * @property {string} id
 * @property {string} value
 * @property {string} label
 */

/**
 * @typedef {Object} CaseStudyCardData
 * @property {string} id
 * @property {string} [category]
 * @property {string} name
 * @property {string} [subtitle]
 * @property {string} [description]
 * @property {MetricItem[]} [metrics]
 * @property {string} [photoUrl]
 * @property {string} [linkUrl]
 * @property {boolean} [isFeatured]
 */

export const METRIC_ITEM_PROP_TYPES = PropTypes.shape({
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
});

export const CASE_STUDY_CARD_PROP_TYPES = PropTypes.shape({
  id: PropTypes.string.isRequired,
  category: PropTypes.string,
  name: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  metrics: PropTypes.arrayOf(METRIC_ITEM_PROP_TYPES),
  photoUrl: PropTypes.string,
  linkUrl: PropTypes.string,
  isFeatured: PropTypes.bool,
});

export const CASE_STUDY_CARD_PROPS = {
  card: CASE_STUDY_CARD_PROP_TYPES.isRequired,
  onCardClick: PropTypes.func,
};
